import { AltraParte } from '../../../models/altraparte';
import { Parte } from '../../../models/parte';

import { ParteAdapter } from '../parte-anagrafica-update/parte-adapter';

export class AltraparteAssociativaAdapter {

  altraParte: AltraParte = new AltraParte();

  constructor(altraParte: AltraParte) {
    this.altraParte.id = altraParte.id;
    this.altraParte.parte = altraParte.parte ?  JSON.parse(JSON.stringify(altraParte.parte)) : new ParteAdapter(new Parte()).parte;
    this.altraParte.note = altraParte.note;
    this.altraParte.categoriaAltraParte = altraParte.categoriaAltraParte ?  JSON.parse(JSON.stringify(altraParte.categoriaAltraParte)) : null;
    this.altraParte.dataAssociazione = altraParte.dataAssociazione;
    this.altraParte.ritirato = altraParte.ritirato ?  altraParte.ritirato : false;
    this.altraParte.cliente = altraParte.cliente ?  altraParte.cliente : false;
    this.altraParte.dataTermine = altraParte.dataTermine;
    this.altraParte.documenti = altraParte.documenti;
    this.altraParte.controparte = altraParte.controparte ?  JSON.parse(JSON.stringify(altraParte.controparte)) : null;
  }
}
